export const DROP_HIGHLIGHT_DELAY                   = 3000 //ms

export const BOARD_CARD_COLOR_NONE                  = 'none'
export const BOARD_CARD_COLOR_PROJECT               = 'project'
export const BOARD_CARD_COLOR_STATUS                = 'status'

export const BOARD_CARD_COLOR_CODING_BORDER_LEFT    = 'left'
export const BOARD_CARD_COLOR_CODING_BORDER_TOP     = 'top'
export const BOARD_CARD_COLOR_CODING_NONE           = 'none'
export const BOARD_CARD_COLOR_CODING_FILL           = 'fill'

export const SELECT_ALL_BUTTON_UPDATE               = "tasks:updateSelectAllButton"

export const SIDE_PANEL_WIDTH                       = 245
export const BREAKDOWN_ALL_VALUES                   = 'all_values'

export const BUS_LIST_BACKGROUND_CHANGED            = 't-list:change-background'

export const BUS_BULK_ACTIONS_UPDATE                = 'rightContainerActions:update'